import { reactQueryGet } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import type { PunditUsersObject } from "@circle-react/hooks/usePunditAPI";
import { createQueryKeyFactory } from "@circle-react/lib/queries/createQueryKeyFactory";
import { QUERY_PERSIST_MAX_AGE } from "@circle-react/providers/QueryClient/persistQueryClient";
import { queryClient } from "@circle-react/providers/QueryClient/reactQueryConfig";
import { queryOptions } from "react-query";

export const punditUserKey = createQueryKeyFactory("pundit-user");

export const punditUserQueries = {
  show: () =>
    queryOptions({
      queryKey: punditUserKey.root(),
      queryFn: () =>
        reactQueryGet<PunditUsersObject>(internalApi.punditUser.show()),
      gcTime: QUERY_PERSIST_MAX_AGE,
      meta: { persist: true },
    }),
};

export const punditUserInvalidations = {
  all: () => queryClient.invalidateQueries({ queryKey: punditUserKey.root() }),
};
